// Affiliate and Review Disclaimers for Amazon Associates Compliance
import { useLanguage } from "@/contexts/LanguageContext";

export const AFFILIATE_DISCLAIMER = "This article may contain affiliate links. If you purchase through these links, we may earn a commission at no additional cost to you.";

export const PRICE_DISCLAIMER = "Price accurate at time of writing. Check latest price on Amazon.";

export const REVIEW_TRANSPARENCY = "Our reviews are based on real-world remote work needs including portability, power autonomy and connectivity reliability while traveling.";

export const CONTACT_EMAIL = "collaborations@nomadlivinglab.com";

// Affiliate Disclaimer Component
export const AffiliateDisclaimer = ({ variant = "block" }) => {
  if (variant === "inline") {
    return (
      <p 
        className="text-xs text-[#1A2B3C]/50 italic"
        data-testid="affiliate-disclaimer-inline"
      >
        {AFFILIATE_DISCLAIMER}
      </p>
    );
  }

  return (
    <div 
      className="bg-[#F9F7F2] border border-[#1A2B3C]/10 rounded-lg p-4 my-6"
      data-testid="affiliate-disclaimer-block"
    >
      <p className="text-sm text-[#1A2B3C]/70 italic">
        <strong className="text-[#1A2B3C]">Affiliate Disclosure:</strong> {AFFILIATE_DISCLAIMER}
      </p>
    </div>
  );
};

// Price Disclaimer Component - Now with translations
export const PriceDisclaimer = () => {
  const { t } = useLanguage();
  return (
    <p 
      className="text-xs text-[#1A2B3C]/50 mt-1"
      data-testid="price-disclaimer"
    >
      {t('price_disclaimer')}
    </p>
  );
};

// Review Transparency Component
export const ReviewTransparency = () => (
  <div 
    className="bg-[#2A9D8F]/5 border border-[#2A9D8F]/10 rounded-xl p-6 my-8"
    data-testid="review-transparency"
  >
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-full bg-[#2A9D8F]/10 flex items-center justify-center shrink-0">
        <span className="text-[#2A9D8F] font-bold text-lg">✓</span>
      </div>
      <div>
        <h4 className="font-['Libre_Baskerville'] font-bold text-[#1A2B3C] mb-2">
          Review Transparency
        </h4>
        <p className="text-sm text-[#1A2B3C]/70">
          {REVIEW_TRANSPARENCY}
        </p>
      </div>
    </div>
  </div>
);

export default {
  AFFILIATE_DISCLAIMER,
  PRICE_DISCLAIMER,
  REVIEW_TRANSPARENCY,
  CONTACT_EMAIL,
  AffiliateDisclaimer,
  PriceDisclaimer,
  ReviewTransparency
};
